// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-page.login-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--background-color);
  padding: 20px;
}

.login-page .login-content {
  width: 100%;
  max-width: 380px;
  animation: loginFadeIn 0.5s ease-in;

}

@keyframes loginFadeIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.login-page .login-header {
  text-align: center;
  margin-bottom: 2.75rem;
}

.login-page .login-header .pi-graduation-cap {
  font-size: 4rem;
  color: var(--primary-color);
  margin-bottom: 0.75rem;
  display: block;
}

.login-page .login-title {
  color: var(--text-primary);
  font-size: 2.2rem;
  font-weight: 600;
  margin: 0.75rem 0 0.5rem 0;
  line-height: 1.2;
}

.login-page .login-subtitle {
  color: var(--text-secondary);
  font-size: 1rem;
  margin: 0;
  font-weight: 400;
  line-height: 1.4;
}

.login-page .login-card.p-card {
  background: var(--bg-card);
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  border: 1px solid var(--border-color);
}

.login-page .login-card.p-card .p-card-body {
  padding: 3rem 2.25rem 2.75rem 2.25rem;
}

.login-page .login-card.p-card .p-card-content {
  padding: 0;
}

.login-page .login-label {
  display: flex;
  align-items: center;
  color: var(--text-primary);
  font-weight: 500;
  margin-bottom: 0.7rem;
  font-size: 1rem;
}

.login-page .login-label .pi {
  margin-right: 0.5rem;
  font-size: 1rem;
}

.login-page .login-input {
  margin-bottom: 0;
}

.login-page .login-input.p-inputtext,
.login-page .login-input .p-inputtext,
.login-page .p-dropdown.login-input,
.login-page .p-inputgroup .login-input {
  border: 1px solid var(--border-color);
  border-radius: 8px;
  padding: 0.95rem 1.1rem;
  transition: all 0.3s ease;
  width: 100%;
  font-size: 1rem;
  background: var(--bg-card) !important;
  color: var(--text-primary) !important;
}

.login-page .p-dropdown.login-input .p-dropdown-label {
  color: var(--text-primary) !important;
  padding: 0;
}

.login-page .p-inputgroup .login-input {
  border-radius: 8px 0 0 8px;
}

.login-page .login-input.p-inputtext:enabled:focus,
.login-page .login-input .p-inputtext:enabled:focus,
.login-page .p-dropdown.login-input.p-focus {
  border-color: var(--accent-color);
  box-shadow: 0 0 0 0.2rem rgba(0, 0, 0, 0.1);
  outline: 0 none;
}

.login-page .login-input .p-inputtext::placeholder {
  color: var(--text-muted);
}

.login-page .login-button.p-button {
  background: var(--accent-color);
  border: none;
  border-radius: 8px;
  padding: 1rem;
  font-size: 1.05rem;
  font-weight: 500;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(74, 144, 226, 0.25);
  width: 100%;
  margin-top: 0.5rem;
}

.login-page .login-button.p-button .p-button-label {
  color: var(--text-on-primary);
  font-weight: 500;
  font-size: 1.05rem;
}

.login-page .login-button.p-button .p-button-icon {
  color: var(--text-on-primary);
  font-size: 1.15rem;
}

.login-page .login-button.p-button:enabled:hover {
  background: var(--accent-color);
  transform: translateY(-2px);
  box-shadow: 0 6px 18px rgba(74, 144, 226, 0.35);
}

.login-page .login-button.p-button:enabled:active {
  transform: translateY(0);
  box-shadow: 0 3px 8px rgba(74, 144, 226, 0.25);
}

.login-page .login-button.p-button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.login-page .login-search-button.p-button {
  background: var(--accent-color);
  border-color: var(--accent-color);
  border-radius: 0 8px 8px 0;
}

.login-page .login-search-button.p-button .p-button-icon {
  color: var(--text-on-primary);
}

.login-page .login-search-button.p-button:enabled:hover {
  background: var(--theme-primary-hover);
  border-color: var(--theme-primary-hover);
}

.login-page .login-footer {
  text-align: center;
  margin-top: 1.75rem;
  padding-top: 1.75rem;
  border-top: 1px solid var(--border-color);
}

.login-page .login-footer>div {
  margin-bottom: 0.5rem;
  font-size: 0.95rem;
  color: var(--text-secondary);
}

.login-page .login-footer>div:last-child {
  margin-bottom: 0;
}

.login-page .login-footer .pi {
  margin-right: 0.3rem;
  font-size: 0.95rem;
}

.login-page .login-link-button {
  color: var(--accent-color);
  text-decoration: none;
  font-size: 0.95rem;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  font-family: inherit;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
}

.login-page .login-link-button:hover {
  color: var(--theme-primary-hover);
  text-decoration: none;
}

.login-page .login-link-button:focus {
  outline: 2px solid #9E2228;
  outline-offset: 2px;
  border-radius: 3px;
}

/* Ajustes para componente Password de PrimeReact */
.login-page .login-input .p-password {
  width: 100%;
  display: block;
}

.login-page .login-input .p-password .p-inputtext {
  width: 100%;
  padding-right: 2.75rem;
}

.login-page .login-input .p-password-icon {
  color: var(--text-secondary);
  transition: color 0.3s ease;
  top: 50%;
  margin-top: -0.5rem;
}

.login-page .login-input .p-password-icon:hover {
  color: var(--theme-primary);
}

.login-page .p-dropdown.login-input .p-dropdown-trigger {
  color: var(--text-secondary);
}

/* Responsive */
@media (max-width: 480px) {
  .login-page .login-content {
    max-width: 100%;
  }

  .login-page .login-card.p-card .p-card-body {
    padding: 2rem 1.75rem;
  }

  .login-page .login-title {
    font-size: 1.6rem;
  }

  .login-page .login-header .pi-graduation-cap {
    font-size: 3rem;
  }

  .login-page .login-subtitle {
    font-size: 0.9rem;
  }
}

/* Dialog styling for Login page */
.p-dialog .p-dialog-header-icon {
  color: #6c757d !important;
}

.p-dialog .p-dialog-header-icon:hover {
  color: #2c3e50 !important;
  background: #f8f9fa !important;
}`, "",{"version":3,"sources":["webpack://./src/pages/login.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;EACnC,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mCAAmC;;AAErC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,0CAA0C;EAC1C,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;EAIE,qCAAqC;EACrC,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,qCAAqC;EACrC,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;EACrC,UAAU;AACZ;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;;EAGE,iCAAiC;EACjC,2CAA2C;EAC3C,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,+BAA+B;EAC/B,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,+CAA+C;EAC/C,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,wBAAwB;EACxB,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,sCAAsC;EACtC,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,oBAAoB;EACpB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,mDAAmD;AACnD;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,eAAe;AACf;EACE;IACE,eAAe;EACjB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,kCAAkC;AAClC;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;AAChC","sourcesContent":[".login-page.login-container {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--background-color);\n  padding: 20px;\n}\n\n.login-page .login-content {\n  width: 100%;\n  max-width: 380px;\n  animation: loginFadeIn 0.5s ease-in;\n\n}\n\n@keyframes loginFadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-20px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.login-page .login-header {\n  text-align: center;\n  margin-bottom: 2.75rem;\n}\n\n.login-page .login-header .pi-graduation-cap {\n  font-size: 4rem;\n  color: var(--primary-color);\n  margin-bottom: 0.75rem;\n  display: block;\n}\n\n.login-page .login-title {\n  color: var(--text-primary);\n  font-size: 2.2rem;\n  font-weight: 600;\n  margin: 0.75rem 0 0.5rem 0;\n  line-height: 1.2;\n}\n\n.login-page .login-subtitle {\n  color: var(--text-secondary);\n  font-size: 1rem;\n  margin: 0;\n  font-weight: 400;\n  line-height: 1.4;\n}\n\n.login-page .login-card.p-card {\n  background: var(--bg-card);\n  border-radius: 12px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);\n  border: 1px solid var(--border-color);\n}\n\n.login-page .login-card.p-card .p-card-body {\n  padding: 3rem 2.25rem 2.75rem 2.25rem;\n}\n\n.login-page .login-card.p-card .p-card-content {\n  padding: 0;\n}\n\n.login-page .login-label {\n  display: flex;\n  align-items: center;\n  color: var(--text-primary);\n  font-weight: 500;\n  margin-bottom: 0.7rem;\n  font-size: 1rem;\n}\n\n.login-page .login-label .pi {\n  margin-right: 0.5rem;\n  font-size: 1rem;\n}\n\n.login-page .login-input {\n  margin-bottom: 0;\n}\n\n.login-page .login-input.p-inputtext,\n.login-page .login-input .p-inputtext,\n.login-page .p-dropdown.login-input,\n.login-page .p-inputgroup .login-input {\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  padding: 0.95rem 1.1rem;\n  transition: all 0.3s ease;\n  width: 100%;\n  font-size: 1rem;\n  background: var(--bg-card) !important;\n  color: var(--text-primary) !important;\n}\n\n.login-page .p-dropdown.login-input .p-dropdown-label {\n  color: var(--text-primary) !important;\n  padding: 0;\n}\n\n.login-page .p-inputgroup .login-input {\n  border-radius: 8px 0 0 8px;\n}\n\n.login-page .login-input.p-inputtext:enabled:focus,\n.login-page .login-input .p-inputtext:enabled:focus,\n.login-page .p-dropdown.login-input.p-focus {\n  border-color: var(--accent-color);\n  box-shadow: 0 0 0 0.2rem rgba(0, 0, 0, 0.1);\n  outline: 0 none;\n}\n\n.login-page .login-input .p-inputtext::placeholder {\n  color: var(--text-muted);\n}\n\n.login-page .login-button.p-button {\n  background: var(--accent-color);\n  border: none;\n  border-radius: 8px;\n  padding: 1rem;\n  font-size: 1.05rem;\n  font-weight: 500;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 12px rgba(74, 144, 226, 0.25);\n  width: 100%;\n  margin-top: 0.5rem;\n}\n\n.login-page .login-button.p-button .p-button-label {\n  color: var(--text-on-primary);\n  font-weight: 500;\n  font-size: 1.05rem;\n}\n\n.login-page .login-button.p-button .p-button-icon {\n  color: var(--text-on-primary);\n  font-size: 1.15rem;\n}\n\n.login-page .login-button.p-button:enabled:hover {\n  background: var(--accent-color);\n  transform: translateY(-2px);\n  box-shadow: 0 6px 18px rgba(74, 144, 226, 0.35);\n}\n\n.login-page .login-button.p-button:enabled:active {\n  transform: translateY(0);\n  box-shadow: 0 3px 8px rgba(74, 144, 226, 0.25);\n}\n\n.login-page .login-button.p-button:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n.login-page .login-search-button.p-button {\n  background: var(--accent-color);\n  border-color: var(--accent-color);\n  border-radius: 0 8px 8px 0;\n}\n\n.login-page .login-search-button.p-button .p-button-icon {\n  color: var(--text-on-primary);\n}\n\n.login-page .login-search-button.p-button:enabled:hover {\n  background: var(--theme-primary-hover);\n  border-color: var(--theme-primary-hover);\n}\n\n.login-page .login-footer {\n  text-align: center;\n  margin-top: 1.75rem;\n  padding-top: 1.75rem;\n  border-top: 1px solid var(--border-color);\n}\n\n.login-page .login-footer>div {\n  margin-bottom: 0.5rem;\n  font-size: 0.95rem;\n  color: var(--text-secondary);\n}\n\n.login-page .login-footer>div:last-child {\n  margin-bottom: 0;\n}\n\n.login-page .login-footer .pi {\n  margin-right: 0.3rem;\n  font-size: 0.95rem;\n}\n\n.login-page .login-link-button {\n  color: var(--accent-color);\n  text-decoration: none;\n  font-size: 0.95rem;\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  font-family: inherit;\n  transition: all 0.2s ease;\n  display: inline-flex;\n  align-items: center;\n}\n\n.login-page .login-link-button:hover {\n  color: var(--theme-primary-hover);\n  text-decoration: none;\n}\n\n.login-page .login-link-button:focus {\n  outline: 2px solid #9E2228;\n  outline-offset: 2px;\n  border-radius: 3px;\n}\n\n/* Ajustes para componente Password de PrimeReact */\n.login-page .login-input .p-password {\n  width: 100%;\n  display: block;\n}\n\n.login-page .login-input .p-password .p-inputtext {\n  width: 100%;\n  padding-right: 2.75rem;\n}\n\n.login-page .login-input .p-password-icon {\n  color: var(--text-secondary);\n  transition: color 0.3s ease;\n  top: 50%;\n  margin-top: -0.5rem;\n}\n\n.login-page .login-input .p-password-icon:hover {\n  color: var(--theme-primary);\n}\n\n.login-page .p-dropdown.login-input .p-dropdown-trigger {\n  color: var(--text-secondary);\n}\n\n/* Responsive */\n@media (max-width: 480px) {\n  .login-page .login-content {\n    max-width: 100%;\n  }\n\n  .login-page .login-card.p-card .p-card-body {\n    padding: 2rem 1.75rem;\n  }\n\n  .login-page .login-title {\n    font-size: 1.6rem;\n  }\n\n  .login-page .login-header .pi-graduation-cap {\n    font-size: 3rem;\n  }\n\n  .login-page .login-subtitle {\n    font-size: 0.9rem;\n  }\n}\n\n/* Dialog styling for Login page */\n.p-dialog .p-dialog-header-icon {\n  color: #6c757d !important;\n}\n\n.p-dialog .p-dialog-header-icon:hover {\n  color: #2c3e50 !important;\n  background: #f8f9fa !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
